function moveFeaturedProduct() {
  const sectionWrapper = document.querySelector('.product-callout');
  const ctaButton = sectionWrapper.querySelector('.product-callout__button');
  
  sectionWrapper.style.backgroundColor = '#F8D0C580';
  ctaButton.style.backgroundColor = '#477577';
  ctaButton.style.textDecoration = 'none';
  const ghost = document.querySelector('.product-ghost-container');

  if (!sectionWrapper || !ghost) return;

  // Insert the featured product **after** the ghost element
  ghost.insertAdjacentElement("afterend", sectionWrapper);

}

// Run when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", moveFeaturedProduct);
} else {
  moveFeaturedProduct();
}